import {
    MapElementProvider,
    type MapElementProviderProps,
} from '../contextProviders/MapElementProvider';
import MapElementModal from '../../../graph/MapElementModal';
import { ApprovalProvider } from '../contextProviders/ApprovalProvider';
import ApprovalRouter from '../approval/ApprovalRouter';

const Approval = (props: MapElementProviderProps) => {
    return (
        <MapElementProvider {...props} defaultScreen={'approval'} elementType={'approval'}>
            <MapElementModal>
                <ApprovalProvider defaultScreen={'approval'}>
                    <ApprovalRouter />
                </ApprovalProvider>
            </MapElementModal>
        </MapElementProvider>
    );
};

export default Approval;
